import APIMapper from './APIMapper';
import EntryController from "../../controllers/EntryController";
import * as EntityTypes from '../constants/entityTypes';

class EntryAPIMapper extends APIMapper {
  update(change) {
    const { item, onSuccess, onError } = change;

    return EntryController.put(item.dependencies.get(EntityTypes.WIDGET), item.nextValue)
      .then(onSuccess)
      .catch(onError);
  }

  delete(change) {
    const { item, onSuccess, onError } = change;

    return EntryController.delete(item.dependencies.get(EntityTypes.WIDGET), item.prevValue.id)
      .then(onSuccess)
      .catch(onError);
  }
}

export default new EntryAPIMapper();
